module.exports = __webpack_public_path__ + "img/ico048.01622720.svg";